import SectionHeading from "@/pages/home/components/SectionHeading";
import { watchModes } from "@/mocks/homeContent";

export default function WatchSection() {
  return (
    <section id="watch" className="scroll-mt-24 bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="观看方式"
          title="在线观看、完整版与高清播放分别指什么"
          desc="搜索时常会看到几个相近的说法。这里逐一说明它们的含义与差别，帮助你判断哪种更符合自己的需求。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6">
          {watchModes.map((mode) => (
            <article
              key={mode.title}
              className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-xl text-background-50">
                  <i className={mode.icon}></i>
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-950">
                  {mode.title}
                </h3>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                {mode.desc}
              </p>
              <ul className="mt-4 flex flex-wrap gap-2">
                {mode.points.map((p) => (
                  <li
                    key={p}
                    className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900"
                  >
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className="ri-check-line"></i>
                    </span>
                    {p}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        <div className="mt-8 rounded-lg border border-primary-200 bg-primary-50 p-5 md:p-6">
          <div className="flex items-start gap-3">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-500 text-lg text-background-50">
              <i className="ri-information-line"></i>
            </span>
            <p className="text-sm leading-relaxed text-foreground-700 md:text-base">
              说明：以上为对相关说法的常识性解释，用于帮助理解「在线观看」「完整版」「高清播放」「无删减在线」「免费观看」「全集在线」等表述的一般含义。具体资源的可用情况与获取方式请以你实际使用的正规平台说明为准。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}